<template>
  <div class="enter web-content">
    <div class="enter_steps">
      <el-steps :active="form.step" align-center>
        <el-step v-if="form.type == 'apply'" title="绑定会员手机"></el-step>
        <el-step v-if="form.type == 'regist'" title="注册销巴会员"></el-step>
        <el-step title="选择店铺类型"></el-step>
        <el-step title="填写店铺信息"></el-step>
        <el-step title="上传店铺资质"></el-step>
      </el-steps>
    </div>
    <phone v-show="form.step == 0 && form.type == 'apply'" v-model="form"></phone>
    <regist v-show="form.step == 0 && form.type == 'regist'" v-model="form"></regist>
    <shop v-show="form.step == 1" v-model="form"></shop>
    <offline v-show="form.step == 2 && form.shopType == 'offshop'" v-model="form"></offline>
    <online v-show="form.step == 2 && form.shopType == 'onshop'" v-model="form"></online>
    <credentials v-show="form.step == 3" v-model="form"></credentials>
  </div>
</template>
<script>
import phone from "./phone";
import shop from "./shop";
import offline from "./offline";
import online from "./online";
import regist from "./regist";
import credentials from "./credentials";
export default {
  data() {
    return {
      form: {
        step: 0,
        type: "apply",
        shopType: "",
        onshop: {},
        offshop: {},
        credentials: {}
      }
    };
  },
  components: {
    phone,
    shop,
    offline,
    online,
    regist,
    credentials
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.enter {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;

  .enter_steps {
    width: 476px;
    margin: 0 auto;
    padding-top: 48px;
    .el-steps {
      .el-step {
        .el-step__head {
          .el-step__line {
            top: 50%;
            height: 0;
            border-top: 1px dashed #c0c0c0;
            background: none;
            left: 77%;
            right: -24%;
            .el-step__line-inner {
              display: none;
            }
          }
          .el-step__icon {
            border: 1px solid #c0c0c0;
            width: 48px;
            height: 48px;
            background: #fff;
            .el-step__icon-inner {
              font-size: 24px;
              color: #c0c0c0;
              font-weight: bold;
            }
          }
        }
        .is-process {
          .el-step__icon {
            background: #f5a702;
            border: none;
            .el-step__icon-inner {
              color: #fff;
            }
          }
        }
        .is-finish {
          .el-step__line {
            border-top: 1px dashed #f5a702;
          }
          .el-step__icon {
            background: #fefaf2;
            border: none;
            .el-step__icon-inner {
              color: #f5a702;
            }
          }
        }
        .el-step__main {
          margin-top: 10px;
          .el-step__title {
            font-size: 14px;
            color: #c0c0c0;
          }
          .is-process {
            color: #f5a702;
            font-weight: 600;
          }
          .is-finish {
            color: #f5a702;
          }
        }
      }
    }
  }

  .enter_form {
    margin: 42px auto;

    .el-form {
      .el-form-item {
        .el-form-item__label {
          font-size: 16px;
          color: #555555;
          padding: 0;
          height: 40px;

          .suffix {
            margin-left: 16px;

            .el-checkbox__label {
              padding-left: 8px;
            }
          }
        }
        .el-form-item__content {
          display: flex;
          .el-input {
            .el-input__inner {
              height: 55px;
            }
          }
        }
      }
    }
    .btn-submit {
      .el-button {
        width: 100%;
        line-height: 36px;
        span {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .el-date-editor.el-input {
      width: auto;
    }
  }
}
.amap-sug-result {
  z-index: 9999999999;
}
</style>